import ILocationSearch from '../interfaces/ilocation-search';
import ILocationSearchType from '../interfaces/ilocation-search-type';
import axios from 'axios';
import IPagedResponse from '../interfaces/ipaged-response';

export class Locations {
    private static model: IPagedResponse;

    public async getLocations(coords: ILocationSearch, pageNumber: number, pageSize: number): Promise<IPagedResponse> {
        await axios.post<IPagedResponse>('/Locations/GetLocations',
            {
                coords,
                pageNumber,
                pageSize
            })
            .then((response) => {
                Locations.model = response.data;
            }).catch((error) => {
                Locations.model = {
                    Data: [],
                    TotalResults: 0,
                    PageNumber: 1,
                    PageSize: 0
                };
                throw new Error(error);
            });
        return Locations.model;
    }

    public async getLocationTypes(): Promise<ILocationSearchType[]> {
        let locationTypes: ILocationSearchType[] = [];
        await axios.get<ILocationSearchType[]>('/Locations/GetLocationTypes')
            .then((response) => {
                locationTypes = response.data;
                locationTypes.forEach((lst: ILocationSearchType) => lst.Checked = lst.Checked ?? true);
            });
        return locationTypes;
    }

    public async getFullStateName(stateAbbreviation: string): Promise<string> {
        let fullStateName: string = '';
        await axios.get<string>('/Mobile/Locations/GetFullStateName',
            {
                params: {
                    abbreviation: stateAbbreviation
                }
            })
            .then((response) => {
                fullStateName = response.data;
            });
        return fullStateName;
    }

    public async getMobileMaxSearchResults(): Promise<number> {
        let pageSize: number = 10;
        await axios.get<number>('/Mobile/Locations/GetMobileMaxSearchResults')
            .then((response) => {
                pageSize = response.data;
            });
        return pageSize;
    }

    public async getWidgetTitle(): Promise<string> {
        let widgetTitle: string = '';
        await axios.get<string>('/Locations/GetWidgetTitle')
            .then((response) => {
                widgetTitle = response.data;
            });
        return widgetTitle;
    }

    public async getCurrentUserAsync(): Promise<string> {
        let userId: string = '';
        await axios.get<string>('/Mobile/Locations/GetCurrentUser')
            .then((response) => {
                userId = response.data;
            });
        return userId;
    }
}